import { BranchService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";
import { IBranch, IBranchBase } from "../../shared/types";

const service = new BranchService();
export const branchThunks = createCRUDThunksLegacy<IBranch, IBranchBase>({
  service,
  resourceName: "branches",
});
